export const blockIconsAndroidUsbNew = (
	<span className='material-symbols-outlined'>usb</span>
);
